import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-evaluacion-pesquisa',
  templateUrl: './evaluacion-pesquisa.component.html',
  styleUrls: ['./evaluacion-pesquisa.component.scss'],
})
export class EvaluacionPesquisaComponent implements OnInit {
  constructor(private fb: FormBuilder) {}
  form: FormGroup;
  @Input() data: { task: any };

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      involucrado: [values ? values.involucrado : false, [Validators.required]],
    });
  }
}
